import axios from "axios";
import { refreshToken } from "./auth";

// Use environment variable for API URL, fallback to localhost for development
const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";
const BASE_URL = `${API_BASE_URL}/api`;
const AUTH_WHITELIST = ["/login/", "/auth/google/", "/refresh/"];

const API = axios.create({
    baseURL: BASE_URL,
});

API.interceptors.request.use((config) => {
    if (!AUTH_WHITELIST.some((endpoint) => config.url.includes(endpoint))) {
        const token = localStorage.getItem("access_token");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
    }
    
    return config;
});

API.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            const newAccessToken = await refreshToken();
            if (newAccessToken) {
                originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
                return API(originalRequest);
            }
        }
        
        return Promise.reject(error);
    }
);

export default API;